<template>
  <!-- Analysis -->
  <div class="row f-row justify-content-center h-100">
    <div class="f-row h-100">
      <div
        class="left-sidebar-front-div"
        v-if="userSelections.visibleLeft"
        @click="changeVisible"
      ></div>
      <!-- Sidebar lateral -->
      <LeftSidebarComm
        :activeElements="activeElements"
        :commodityInformation="commodityDefs"
        :commoditySpecs="commoditySpecs"
        :contractSelected="contractSelected"
        :conversionAvailable="!conversionAvailable"
        :currencyNumber="userCurrencySelection"
        :currencySpecs="currencySpecsReactive"
        :listAnalysis="viewSelected"
        :listContracts="optionsContract.slice(0, 6)"
        :selectedAnalysis="['userSelections']['selectedAnalysis']"
        :selectedAnalysisParent="['userSelections']['selectedAnalysisParent']"
        :showLoading="showLoading"
        :spot="spotResult"
        :visibleLeft="userSelections.visibleLeft"
        @eventOnLeftSidebarAnalysis="onLeftSidebarAnalysis"
        @eventOnUserClickLeftSidebarShow="onUserClickLeftSidebarShow"
        @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
        @onUserCommoditySelection="onUserCommoditySelection"
        @onUserChangeAnalysis="onUserChangeAnalysis"
        @onChangeContract="onChangeContract"
        @onChangeContractMonthYear="onChangeContractMonthYear"
        @onExecuteOperation="onExecuteOperation"
        @onSelectedOperation="onSelectedOperation"
        @onUserCurrencySelection="onUserCurrencySelection"
        @onClientFreightTariffChange="onClientFreightTariffChange"
      />
      <div class="h-100 d-flex flex-column largeBox row f-row">
        <div class="justify-content-center h-100 row f-row">
          <!-- Currencies -->
          <div v-if="selectedShowView === 'worldCurrencies'" class="col col-12">
            <CurrencyWorld
              :againstCurrency="defaultOperation !== 0"
              :colorTheme="colorTheme"
              :controls="'large'"
              :currencyDefs="currencyDefs"
              :currencyNumber="userCurrencySelection"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis"
                  :updateDate="updatedAt"
                />
              </template>
            </CurrencyWorld>
          </div>
          <!-- Forward and Volatility TODO borrar true -->
          <div v-else-if="selectedShowView === 'pricing'" class="col col-12">
            <Pricing
              :asset="'commodity'"
              :colorTheme="colorTheme"
              :currencyNumber="commodityNumber"
              :processData="processData"
              :showHistory="true"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="'Forwards + Options'"
                  :updateDate="updatedAt"
                  :qtyColumns="12"
                />
              </template>
            </Pricing>
          </div>
          <!-- Commodities -->
          <div
            v-else-if="selectedShowView === 'worldCommodities'"
            class="col col-12"
          >
            <CommoditiesMulti
              :colorTheme="colorTheme"
              :controls="'large'"
              :processData="processData"
              :selectedCommodity="-1"
              :commoditySpecs="commoditySpecs"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </CommoditiesMulti>
          </div>
          <!-- Fundamentals -->
          <div
            v-else-if="selectedShowView === 'fundamentals'"
            class="col col-12"
          >
            <fundamentals-historical
              :colorTheme="colorTheme"
              :processData="processData"
              :commoditySpecs="commoditySpecs"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                  :hasAnalysisName="false"
                  :qtyColumns="3"
                />
              </template>
            </fundamentals-historical>
          </div>
          <!-- Correlations -->
          <div
            v-else-if="selectedShowView === 'correlations'"
            class="col col-12"
          >
            <Correlations
              :colorTheme="colorTheme"
              :contract="contract"
              :currencyNumber="commodityNumber"
              :currencyString="commodityDefs"
              :isCurrency="false"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis"
                  :updateDate="updatedAt"
                />
              </template>
            </Correlations>
          </div>
          <!-- Comparison -->
          <div
            v-else-if="selectedShowView === 'comparison'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Comparison
              :chartDataRaw="dataConverted"
              :colorTheme="colorTheme"
              :commodityString="commodityDefs.fk_idproduct.toUpperCase()"
              :commodityStringLong="commodityStringLong"
              :currencyString="currencyString"
              :dataReady="dataReady"
              :isCurrency="false"
              :processData="processData"
              :showLoadingParent="showLoading"
              :render="render"
              :initCompareType="compareType"
              :initCompareAsset="compareAsset"
              @onComparisonSelection="onComparisonSelection"
              @resizeCharts="resizeCharts"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Comparison>
          </div>
          <!-- Dot plot -->
          <div v-else-if="selectedShowView === 'dotPlot'" class="col col-12">
            <DotPlot :processData="processData" :colorTheme="colorTheme">
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis"
                  :updateDate="updatedAt"
                  :qtyColumns="screenWidth < 1400 && screenWidth > 1100 ? 4 : 5"
                />
              </template>
            </DotPlot>
          </div>
          <!-- Macro -->
          <div v-else-if="selectedShowView === 'macro'" class="col col-12">
            <Fundamentals
              :colorTheme="colorTheme"
              :countrySpecs="countrySpecs"
              :currencyStr="currencyDefs.currency_name"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis"
                  :updateDate="updatedAt"
                />
              </template>
            </Fundamentals>
          </div>
          <!-- Curve Analysis -->
          <div
            v-else-if="selectedShowView === 'curveAnalysis'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <CurveAnalysis
              :colorTheme="colorTheme"
              :commodityDefs="commodityDefs"
              :processData="processData"
              :spot="spotResult"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis"
                  :updateDate="updatedAt"
                />
              </template>
            </CurveAnalysis>
          </div>
          <!-- Commitment of traders -->
          <div
            v-else-if="selectedShowView === 'commitmentTraders'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <CommitmentTraders
              :colorTheme="colorTheme"
              :commodityDefs="commodityDefs"
              :commoditySpecs="commoditySpecs"
              :currencySpecs="currencySpecs"
              :indexSpecs="indexSpecs"
              :isCurrency="false"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </CommitmentTraders>
          </div>
          <!-- Forecasts -->
          <div
            v-else-if="selectedShowView === 'forecast'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Forecast
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :currencyNumber="commodityNumber"
              :currencyString="commodityDefs"
              :dataReady="dataReady"
              :expandLeft="true"
              :hideRight="true"
              :processData="processData"
              :showDumbell="false"
              :showLoading="showLoading"
              :spot="spotResult"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Forecast>
          </div>
          <!-- Forecast Analysis -->
          <div
            v-else-if="selectedShowView === 'forecastAnalysis'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <ForecastAnalysis
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :commodityDefs="commodityDefs"
              :dataReady="dataReady"
              :isCurrency="false"
              :processData="processData"
              :commodityStringLong="commodityStringLong"
              :selectedCurrency="selectedCommodity"
              :commodityName="commodityName"
              :currencyString="commodityDefs"
              :showLoading="showLoading"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </ForecastAnalysis>
          </div>
          <!-- Seasonality -->
          <div
            v-else-if="selectedShowView === 'seasonality'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Seasonality
              :chartDataRaw="dataConverted"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :renderSeasonality="dataReady"
              :selectedCurrency="selectedCommodity"
              :showLoading="showLoading"
              :spot="spotResult"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Seasonality>
          </div>
          <!-- Percentiles -->
          <div
            v-else-if="selectedShowView === 'percentiles'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Percentiles
              :chartDataRaw="dataConverted"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :processData="processData"
              :renderPercentile="dataReady"
              :showLoading="showLoading"
              :spot="spotResult"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="''"
                  :updateDate="updatedAt"
                />
              </template>
            </Percentiles>
          </div>
          <!-- Trend -->
          <div
            v-else-if="selectedShowView === 'trend'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <Trends
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :processData="processData"
              :showLoading="showLoading"
              :spot="spotResult"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="'Historical trends'"
                  :updateDate="updatedAt"
                  :qtyColumns="12"
                />
              </template>
            </Trends>
          </div>
          <!-- Relative Value -->
          <div
            v-else-if="selectedShowView === 'relativeValue'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <RelativeValue
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :contract="contract"
              :currencyNumber="commodityNumber"
              :currencyString="commodityDefs"
              :dataReady="dataReady"
              :expandRight="false"
              :hideLeft="false"
              :isCurrency="false"
              :processData="processData"
              :spot="spot"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis + ' analysis'"
                  :updateDate="updatedAt"
                  :qtyColumns="12"
                />
              </template>
            </RelativeValue>
          </div>
          <!-- Technical Analysis -->
          <div
            v-else-if="selectedShowView === 'techAnalysis'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <TechnicalAnalysis
              :analysisName="analysisName"
              :chartDataRaw="dataConverted"
              :colorTheme="colorTheme"
              :commodityName="commodityName"
              :commodityStringLong="commodityStringLong"
              :dataReady="dataReady"
              :isCurrency="false"
              :processData="processData"
              :selectedCurrency="selectedCommodity"
              :showLoading="showLoading"
              :showLoadingSpot="showLoadingSpot"
              :spot="showLoadingSpotFactor === true ? null : spotResult"
              :spotAnimate="spotAnimate"
              :spotFactor="spotFactor"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="'Technical analysis'"
                  :updateDate="updatedAt"
                />
              </template>
            </TechnicalAnalysis>
          </div>
          <!-- Patterns -->
          <div
            v-else-if="selectedShowView === 'patterns'"
            style="height: 100%; width:100%; padding: 0;"
          >
            <PatternRecognition
              :chartDataRaw="chartDataRaw"
              :colorTheme="colorTheme"
              :dataReady="dataReady"
              :processData="processData"
              :showLoading="showLoading"
              :totalCurrencyExposure="totalCurrencyExposure"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="
                    'History (hover over chart to visualize patterns)'
                  "
                  :updateDate="updatedAt"
                  :qtyColumns="12"
                />
              </template>
            </PatternRecognition>
          </div>

          <!-- Price Table -->
          <div v-else-if="selectedShowView === 'prices'" class="col col-12">
            <PriceTable
              :colorTheme="colorTheme"
              :commodityNumber="commodityNumber"
              :commoditySpecs="commoditySpecs"
            />
          </div>
          <!-- CPO Colombia -->
          <div
            v-else-if="selectedShowView === 'colombiaCpo'"
            class="col col-12"
          >
            <CPOColombia
              :colorTheme="colorTheme"
              :commoditySpecs="commoditySpecs"
              :currencySpecs="currencySpecs"
              :processData="processData"
            >
              <template v-slot:spot>
                <DetailsDisplay
                  :colorTheme="colorTheme"
                  :spot="showLoadingSpotFactor === true ? null : spotResult"
                  :showLoadingSpot="showLoadingSpot"
                  :spotAnimate="spotAnimate"
                  :analysisName="activeElements.analysis"
                  :updateDate="updatedAt"
                />
              </template>
            </CPOColombia>
          </div>
          <!-- Summary -->
          <div
            v-else-if="summarySelected === true"
            style="height: 100%; width:100%; padding: 0;"
          >
            Summary
          </div>
          <!-- If nothing selected -->
          <div v-else style="height: 95%;width:100%">
            <div
              class="text-center"
              style="width:100%; background: var(--background-alpha); color: var(--textactive); font-size: 1.2rem;"
            >
              Select analysis on the right panel
            </div>
            <div
              :style="{
                backgroundImage:
                  'url(' + require('@/assets/images/fondoNY6.jpg') + ')',
              }"
              style="height: 100%; width:100%; background-size: cover;"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <Messages :modal_message="modal_processing_message" />
    <Messages :modal_message="modal_process_finished_message" />
  </div>
</template>

<script>
import { apiService } from "@/_services";
import {
  colorSelection,
  darkBackground,
  dateFormat,
  formatPercent,
  grayLightBackground,
  numberFormat,
  textactive2,
} from "@/_core/_helpers/_parametric_tools";
import { CommoditiesOps } from "@/_core/data/CommoditiesOps";
import { format, select, selectAll } from "d3";
import {
  formatDate_YMD,
  formatDate_DDMMMYHMS,
  isMonthYearCode,
  timeParseNoNull2,
} from "@/_core/_helpers/_helpers";
import { getMenu } from "@/_core/data/api_calls/menu/getMenu";
import {
  getDefaultMarketsPreferences,
  getDefaultView,
} from "@/_core/data/Markets";
import { ProcessData } from "@/_core/data/ProcessData";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { TotalCurrencyExposure } from "@/_core/data/TotalCurrencyExposure";
import CommitmentTraders from "@/components/markets/CommitmentOfTraders";
import CommoditiesMulti from "@/components/markets/CommoditiesMulti";
import Comparison from "@/components/markets/Comparison";
import Correlations from "@/components/markets/Correlations";
import CPOColombia from "@/components/markets/CPOColombia";
import CurrencyWorld from "@/components/markets/CurrencyWorld";
import CurveAnalysis from "@/components/markets/CurveAnalysis";
import DetailsDisplay from "@/components/markets/MarketDetails/DetailsDisplay.vue";
import DotPlot from "./DotPlot.vue";
import Forecast from "@/components/markets/Forecast.vue";
import ForecastAnalysis from "@/components/markets/ForecastAnalysis.vue";
import Fundamentals from "@/components/markets/Fundamentals";
import FundamentalsHistorical from "./Fundamentals/FundamentalsHistorical.vue";
import LeftSidebarComm from "./Sidebar/LeftSidebarComm.vue";
import Messages from "@/components/modals/Messages.vue";
import {
  marketsRouteSync,
  slugifyProductItem,
} from "@/components/markets/marketsRouteSync";
import PatternRecognition from "@/components/markets/PatternRecognition.vue";
import Percentiles from "@/components/markets/Percentiles";
import PriceTable from "@/components/markets/PriceTable";
import Pricing from "@/components/markets/Pricing.vue";
import RelativeValue from "@/components/markets/RelativeValue.vue";
import Seasonality from "@/components/markets/Seasonality";
import TechnicalAnalysis from "@/components/markets/TechnicalAnalysis.vue";
import Trends from "@/components/markets/Trends.vue";

export default {
  name: "Commodity",
  mixins: [marketsRouteSync],
  components: {
    CommitmentTraders,
    CommoditiesMulti,
    Comparison,
    Correlations,
    CPOColombia,
    CurrencyWorld,
    CurveAnalysis,
    DotPlot,
    Forecast,
    ForecastAnalysis,
    Fundamentals,
    Messages,
    LeftSidebarComm,
    PatternRecognition,
    Percentiles,
    PriceTable,
    Pricing,
    RelativeValue,
    Seasonality,
    TechnicalAnalysis,
    Trends,
    DetailsDisplay,
    FundamentalsHistorical,
  },
  props: {
    user: { required: true },
    colorTheme: { required: true, type: Boolean, default: true },
  },
  data() {
    return {
      activeElements: {
        commodity: "",
        analysis: "",
        continuous: "",
        contract: "",
        operation: "",
      },
      againstCurrency: false,
      allOperations: [
        { operation: "&#8709;", id: 0 },
        { operation: "&#215;", id: 1 },
        { operation: "&#247;", id: 2 },
      ],
      chartDataRaw: [],
      colorSelection: colorSelection,
      commoditiesOps: null,
      commodityDefs: { is_cents: false, fk_idcurrency: "USD", fk_idunit: "mt" },
      commodityNumber: 0,
      commodityName: "na",
      commoditySpecs: [],
      contract: 1,
      contractMonthYear: null,
      contractExpanded: false,
      contractSelected: 1,
      // Comparison view selection (asset type + asset), synced to the URL.
      compareType: null,
      compareAsset: null,
      conversionAvailable: true,
      converted: true,
      countrySpecs: [],
      currencyCommodityUndefined: {},
      currencyDefs: { currency_name: "na" },
      currencyHistorical: [],
      currencySpecs: [],
      currencySpecsReactive: [],
      currencyString: { currency_name: "N.A/N.A" },
      dataConverted: [],
      dataReady: 0,
      defaultSpotData: [1, 2, 3, 4, 5, 6],
      dateFormat: dateFormat,
      defaultOperation: 0,
      factorUpdatedAt: null,
      faildGetHistoricalData: true,
      formatDate_YMD: formatDate_YMD,
      formatPercent: formatPercent,
      freight: 0,
      indexSpecs: [],
      initCommodityDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      initCurrencyDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 20),
      ),
      marketsAsset: "commodity",
      // routes that do not depend on the selected commodity → markets-global route
      marketsGlobalKeys: [
        "worldCurrencies",
        "worldCommodities",
        "dotPlot",
        "macro",
        "fundamentals",
        "colombiaCpo",
      ],
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      noneActive: true,
      numberFormat: numberFormat,
      optionsContract: [
        { contract_month_year: "JAN00", last_trading_date: new Date() },
      ],
      previousSpot: null,
      previousSpotFactor: 0,
      processData: null,
      quanspireMenuData: {},
      render: false,
      selectedCommodity: 3,
      selectedView: 0,
      screenWidth: 0,
      showLoading: false,
      showLoadingComm: false,
      showLoadingSpot: false,
      showLoadingSpotFactor: false,
      showWarningDiv: false,
      spot: null,
      spotAnimate: 0,
      spotData: null,
      spotExistsCurrency: false,
      spotFactor: null,
      spotFactorAnimate: 0,
      summarySelected: false,
      tariff: 0,
      tooltip: null,
      totalCurrencyExposure: null,
      updatedAt: null,
      userCurrencySelection: 3,
      userCurrencySelectionCommodity: null,
      userSelections: {
        selectedAnalysis: "",
        selectedAnalysisParent: "",
        visibleLeft: false,
      },
      onUsers: {
        elementChange: "",
      },
      validReadyCommodities: true,
      view: {
        techAnalysis: { value: 0, name: "Technical analysis", show: true },
      },
      viewDefault: { value: 0, name: "Technical analysis", show: true },
      view_quanspire: {},
      viewUser: {},
    };
  },
  created() {
    this.viewDefault = getDefaultView();
    this.markets_preferences = getDefaultMarketsPreferences(this)["choices"];
    try {
      this.totalCurrencyExposure = new TotalCurrencyExposure(
        "",
        "api",
        apiService,
        this.spot,
        null,
        this.selectedDaysCandle,
        this.intervalCandle,
        0,
      );
      this.processData = new ProcessData();
      this.commoditiesOps = new CommoditiesOps(this);
    } catch (error) {
      console.error(`Error: data classes ${error}`);
    }
    try {
      this.currencySpecs = this.$store.state.currencies.all.items;
    } catch (error) {
      console.error(`Error currencies ${error}`);
    }
    try {
      this.countrySpecs = this.$store.state.countries.all.items;
    } catch (error) {
      console.error(`Error countries ${error}`);
    }
    try {
      this.commoditySpecs = this.$store.state.commodities.all.items;
    } catch (error) {
      console.error(`Error currencies ${error}`);
    }
    try {
      this.indexSpecs = this.$store.state.indexes.all.items;
    } catch (error) {
      console.error(`Error indexes ${error}`);
    }
    try {
      this.selectedCommodity = this.markets_preferences.selected_commodity;
    } catch (error) {
      console.error(`Error commodities preferences ${error}`);
    }
    const isMarketsRoute = this.$route.params.productType === this.marketsAsset;
    if (isMarketsRoute) {
      const routeItemSlug = this.marketsRouteItemFromRoute(this.$route);
      const routeItemIndex = routeItemSlug
        ? this.marketsFindItem(routeItemSlug)
        : -1;
      if (routeItemIndex > -1) {
        this.selectedCommodity = routeItemIndex;
        this.markets_preferences.selected_commodity = routeItemIndex;
      }
    }
    const commodityCount = Array.isArray(this.commoditySpecs)
      ? this.commoditySpecs.length
      : 0;
    if (
      !Number.isInteger(this.selectedCommodity) ||
      this.selectedCommodity < 0 ||
      this.selectedCommodity >= commodityCount
    ) {
      this.selectedCommodity = commodityCount > 0 ? 0 : this.selectedCommodity;
      this.markets_preferences.selected_commodity = this.selectedCommodity;
    }
    this.showLoadingSpot = true;
    this.showLoadingSpotFactor = true;
    this.showLoading = true;
    this.currencyDefs = this.currencySpecs[11];
    const cmdtyDefs = this.commoditySpecs[this.selectedCommodity];
    if (cmdtyDefs) {
      Object.assign(this, { commodityDefs: cmdtyDefs });
      this.contractSelected = cmdtyDefs.selected_contract;
      this.contract = cmdtyDefs.selected_contract;
    }
    const routeContract = isMarketsRoute ? this.$route.query.contract : null;
    const routeMonthYear = routeContract
      ? String(routeContract).toUpperCase()
      : null;
    if (
      routeContract &&
      /^\d+$/.test(routeContract) &&
      Number(routeContract) >= 1
    ) {
      this.contract = Number(routeContract);
      this.contractSelected = this.contract;
    } else if (routeMonthYear && isMonthYearCode(routeMonthYear)) {
      this.contract = null;
      this.contractMonthYear = routeMonthYear;
      this.contractSelected = routeMonthYear;
    }
    this.commodityNumber = this.commodityDefs.pk_idcommodity;
    this.commodityName = this.commodityDefs.commodity_name;
    Object.assign(this.activeElements, {
      commodity: this.commodityName,
      continuous: this.contractMonthYear ? null : this.contractSelected,
      contract: this.contractMonthYear,
      analysis: this.viewSelected[this.selectedShowView].name,
      operation: this.defaultOperation,
    });
    let asset = "commodity";
    getMenu(this, asset).then(() => this.onMarketsMenuLoaded());
    this.commoditiesOps.getSpotCommoditiesData();
    // this.commoditiesOps.getSpotCommoditiesData(true);

    document.title = "Markets | Cmdty";
  },
  mounted() {
    this.tooltip = select("#whole-page-div")
      .append("div")
      .style("opacity", 1)
      .style("margin", 0)
      .style("padding", "8px")
      .style("text-align", "center")
      .style("background", darkBackground(this.colorTheme))
      .style("border", grayLightBackground(this.colorTheme))
      .style("color", textactive2(this.colorTheme))
      .attr("class", "tooltip")
      .style("font-size", "0.8rem")
      .style("width", "350px")
      .style("right", "-1000000px")
      .style("top", "0px")
      .html("");

    this.updateScreenWidth();
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
  },
  computed: {
    commodityStringLong() {
      if (!this.commodityDefs || !this.commodityDefs.fk_idproduct) return "";
      let len = this.chartDataRaw.length;
      let str =
        len > 0 && this.chartDataRaw[len - 1].contract_month_year != null
          ? " - currently " + this.chartDataRaw[len - 1].contract_month_year
          : "";
      return (
        this.commodityDefs.fk_idproduct.toUpperCase() +
        " - contract # " +
        this.contract +
        str +
        " (" +
        (this.commodityDefs.is_cents
          ? "USc"
          : this.commodityDefs.fk_idcurrency) +
        "/" +
        this.commodityDefs.fk_idunit +
        ")"
      );
    },
    defContract() {
      return this.commoditySpecs[this.selectedCommodity].selected_contract;
    },
    viewSelected() {
      try {
        if (this.commoditySpecs.length > 0) {
          if (
            this.contract ===
            this.commoditySpecs[this.selectedCommodity].selected_contract
          ) {
            return this.view;
          } else {
            return this.viewDefault;
          }
        } else {
          return this.viewDefault;
        }
      } catch (error) {
        console.error(error);
        return this.viewDefault;
      }
    },
    spotResult() {
      if (
        this.spotFactor === 0 ||
        this.spotFactor === null ||
        this.showLoadingSpotFactor === true
      ) {
        return this.spot;
      }
      let spt;
      if (this.defaultOperation === 0) {
        spt = this.spot;
      } else if (this.defaultOperation === 1) {
        spt =
          (this.spot + this.freight) *
          this.spotFactor *
          (1 + this.tariff / 100);
      } else if (this.defaultOperation === 2) {
        spt =
          ((this.spot + this.freight) * (1 + this.tariff / 100)) /
          this.spotFactor;
      }
      return spt;
    },
    selectedViewBoolean: {
      get() {
        return this.selectedView === 1;
      },
      set() {
        return false;
      },
    },
    viewResult: function() {
      var ave = 0;
      var keys = Object.keys(this.viewSelected);
      for (const item of keys) {
        ave += this.viewSelected[item].value;
      }
      return Math.round((10 * ave) / keys.length) / 10;
    },
    selectedShowView: function() {
      let sel = "techAnalysis";
      let analysisName = "";
      let keys = Object.keys(this.viewSelected);
      for (const item of keys) {
        if (this.viewSelected[item].show === true) {
          sel = item;
          analysisName = this.viewSelected[item];
        }
      }
      if (analysisName) {
        Object.assign(this.activeElements, {
          analysis: analysisName.name,
        });
      }
      return sel;
    },
    analysisName() {
      return this.viewDefault.name;
    },
  },
  watch: {
    colorTheme() {
      this.tooltip
        .style("background", darkBackground(this.colorTheme))
        .style("border", grayLightBackground(this.colorTheme))
        .style("color", textactive2(this.colorTheme));
    },
    selectedShowView(newVal) {
      this.commoditiesOps.convertAvailable();
      Object.assign(this.activeElements, {
        analysis: this.viewSelected[newVal].name,
      });
    },
    chartDataRaw: {
      handler(data) {
        this.verifySpotData();
        this.verifyLastTwoDates(this, data);
      },
      deep: true,
    },
    "userSelections.visibleLeft": {
      handler() {},
      deep: true,
    },
    optionsContract: {
      handler() {},
      deep: true,
    },
    currencySpecs: {
      handler(val) {
        this.currencySpecsReactive = val;
      },
      deep: true,
    },
    contractSelected() {},
  },
  methods: {
    /** ================ user interactions ================ **/
    onChangeContract({ item }) {
      this.contract = item.continuous_contract;
      this.contractSelected = this.contract;
      this.contractMonthYear = null;
      this.contractExpanded = false;
      this.spotFactor = null;
      this.chartDataRaw = [];
      this.commoditiesOps.getSpotCommoditiesData();
      this.commoditiesOps.getSpotCommoditiesData(true);
      Object.assign(this.activeElements, {
        continuous: this.contract,
        contract: this.contractMonthYear,
      });
      this.syncMarketsRoute();
    },
    onChangeContractMonthYear({ item }) {
      this.contract = null;
      this.contractMonthYear = item.contract_month_year;
      this.contractSelected = this.contractMonthYear;
      this.contractExpanded = false;
      this.chartDataRaw = [];
      this.spotFactor = null;
      Object.assign(this.activeElements, {
        continuous: this.contract,
        contract: this.contractMonthYear,
      });

      this.commoditiesOps.getContractMonthYCommData(
        this,
        this.commodityNumber,
        this.contract,
        this.contractMonthYear,
        "commodity_contract",
      );
      this.syncMarketsRoute();
    },
    onHoverHelp(val) {
      let keys = Object.keys(this.commodityDefs);
      if (val && keys.indexOf("text") > -1) {
        this.tooltip
          .style("opacity", 1)
          .style("right", "30px")
          .style("top", "140px")
          .html(this.commodityDefs.text);
      } else {
        this.tooltip
          .style("right", "-1000000px")
          .style("top", "0px")
          .style("opacity", 0)
          .html("");
      }
    },
    onSelectedOperation({ item }) {
      this.defaultOperation = item.id;
      this.spotFactor = null;
      this.currencyHistorical = [];
      this.dataConverted = this.chartDataRaw;
      this.dataReady += 1;
      Object.assign(this.activeElements, {
        operation: this.defaultOperation,
      });
      if (this.defaultOperation !== 0) {
        this.converted = false;
        this.factorUpdatedAt = null;
        this.commoditiesOps.loadCurrencyParams(this);
      }
    },
    changeVisible() {
      Object.assign(this.userSelections, {
        visibleLeft: !this.userSelections.visibleLeft,
      });
      this.$emit("getOpenElements");
    },
    onExecuteOperation() {
      if (this.defaultOperation !== 0) {
        this.converted = true;
        this.showLoadingSpotFactor = true;
        this.commoditiesOps.getSpotData();
      }
    },
    onClientFreightTariffChange({ item, valueInput }) {
      if (item.placeholder === "freight") {
        this.freight = valueInput;
      }

      if (item.placeholder === "tariff") {
        this.tariff = valueInput;
      }
      if (this.defaultOperation !== 0) {
        if (this.dataConverted.length > 0 && this.converted === true) {
          this.commoditiesOps.combineAssets();
        }
      }
    },
    onLeftSidebarAnalysisScenarios({ getEvent }) {
      this.onUsers.elementChange = getEvent;
    },
    resizeCharts() {
      let rBool = this.render;
      for (let i = 0; i < 1; i++) {
        setTimeout(() => {
          Object.assign(this, {
            render: i % 2 === 0 ? !rBool : rBool,
          });
        }, i * 50);
      }

      Object.assign(this, {
        render: !this["render"],
      });
    },
    onLeftSidebarAnalysis({ val, parent }) {
      Object.assign(this["userSelections"], {
        selectedAnalysisParent: parent,
      });
      Object.assign(this["userSelections"], {
        selectedAnalysis: val,
      });
      setTimeout(() => {
        Object.assign(this["userSelections"], {
          visibleLeft: false,
        });
      }, 500);
    },
    onUserClickLeftSidebarShow(val) {
      Object.assign(this["userSelections"], {
        visibleLeft: val,
      });
    },
    onUserSummarySelected() {
      this.summarySelected = !this.summarySelected;
      var keys = Object.keys(this.viewSelected);
      for (const key of keys) {
        Object.assign(this.viewSelected[key], { show: false });
      }
    },
    onUserChangeAnalysis({ item }) {
      item.show = !item.show;
      this.summarySelected = false;
      const keys = Object.keys(this.viewSelected);
      for (const key of keys) {
        Object.assign(this.viewSelected[key], {
          show: item.name === this.viewSelected[key].name,
        });
      }
      Object.assign(this.activeElements, {
        analysis: this.viewSelected[this.selectedShowView].name,
      });
      this.syncMarketsRoute();
    },
    onUserCurrencySelection({ item }) {
      this.spotFactor = null;
      const indexCurr = this.currencySpecs.findIndex(
        (d) => d.currency_name === item.currency_name,
      );
      this.userCurrencySelection = indexCurr;

      if (this.defaultOperation !== 0) {
        this.spotFactor = null;
        this.converted = false;
        this.factorUpdatedAt = null;
        this.commoditiesOps.loadCurrencyParams(this);
      }
    },
    onUserCommoditySelection({ item }) {
      this.spot = null;
      const indexComm = this.commoditySpecs.findIndex(
        (d) => d.pk_idcommodity === item.pk_idcommodity,
      );
      Object.assign(this, {
        selectedCommodity: indexComm,
      });
      this.chartDataRaw.splice(0, this.chartDataRaw.length);
      this.dataConverted.splice(0, this.dataConverted.length);
      this.validReadyCommodities = true;
      this.showLoadingSpot = true;
      this.showLoading = true;
      let cmdtyDefs = this.commoditySpecs[this.selectedCommodity];
      this.commodityNumber = cmdtyDefs.pk_idcommodity;
      this.commodityName = cmdtyDefs.commodity_name;
      this.contract = cmdtyDefs.selected_contract;
      this.markets_preferences.selected_commodity = this.selectedCommodity;
      this.$store.state.user_preferences.all.items.markets_choices = this.markets_preferences;
      this.spotFactor = null;
      saveUserPreferences(this);
      let asset = "commodity";
      const menuPromise = getMenu(this, asset);
      Object.assign(this, {
        commodityDefs: cmdtyDefs,
      });
      this.contractSelected = this.contract;
      this.contractMonthYear = null;
      this.commoditiesOps.getSpotCommoditiesData();
      this.commoditiesOps.getSpotCommoditiesData(true);
      Object.assign(this.activeElements, {
        commodity: this.commodityName,
        continuous: this.contractSelected,
        contract: null,
        operation: 0,
      });
      this.syncMarketsRoute();
      return menuPromise.then(() => this.syncMarketsRoute(true));
    },
    marketsMenu() {
      return this.viewSelected;
    },
    marketsItemSlug() {
      return slugifyProductItem(this.commodityDefs.fk_idproduct);
    },
    marketsFindItem(slug) {
      const target = slugifyProductItem(slug);
      let indexComm = this.commoditySpecs.findIndex(
        (d) => slugifyProductItem(d.fk_idproduct) === target,
      );
      if (indexComm < 0) {
        indexComm = this.commoditySpecs.findIndex(
          (d) => slugifyProductItem(d.commodity_name) === target,
        );
      }
      return indexComm;
    },
    applyMarketsItem(slug) {
      const indexComm = this.marketsFindItem(slug);
      if (indexComm < 0 || indexComm === this.selectedCommodity) {
        return Promise.resolve();
      }
      return this.onUserCommoditySelection({
        item: this.commoditySpecs[indexComm],
      });
    },
    onComparisonSelection({ type, asset }) {
      this.compareType = type || null;
      this.compareAsset = asset || null;
      if (this.selectedShowView === "comparison") {
        this.syncMarketsRoute();
      }
    },
    marketsRouteQuery(routeName) {
      if (routeName !== "markets-analysis") return {};
      const query = {};
      const defaultContract = this.commoditySpecs[this.selectedCommodity]
        .selected_contract;
      if (
        this.contractSelected != null &&
        this.contractSelected !== defaultContract
      ) {
        query.contract = String(this.contractSelected);
      }
      if (this.selectedShowView === "comparison" && this.compareType) {
        query.compareType = this.compareType;
        if (this.compareAsset) query.compareAsset = this.compareAsset;
      }
      return query;
    },
    contractsLoaded() {
      const list = this.optionsContract;
      return (
        Array.isArray(list) &&
        list.length > 0 &&
        list[0].contract_month_year !== "JAN00"
      );
    },
    isValidContractParam(contractParam) {
      if (contractParam == null) return false;
      const value = String(contractParam);
      if (/^\d+$/.test(value)) {
        const continuous = Number(value);
        if (continuous < 1) return false;
        if (
          this.contractsLoaded() &&
          continuous > this.optionsContract.length
        ) {
          return false;
        }
        return true;
      }
      const monthYear = value.toUpperCase();
      if (!isMonthYearCode(monthYear)) return false;
      if (this.contractsLoaded()) {
        return this.optionsContract.some(
          (o) => o.contract_month_year === monthYear,
        );
      }
      return true;
    },
    applyMarketsQuery(route) {
      if (route.name !== "markets-analysis") return;
      if (route.query.compareType) {
        this.compareType = route.query.compareType;
        this.compareAsset = route.query.compareAsset || null;
      }
      const contractParam = route.query.contract;
      const defaultContract = this.commoditySpecs[this.selectedCommodity]
        .selected_contract;
      if (!contractParam || !this.isValidContractParam(contractParam)) {
        if (this.contractSelected !== defaultContract) {
          this.onChangeContract({
            item: { continuous_contract: defaultContract },
          });
        }
        return;
      }
      if (/^\d+$/.test(contractParam)) {
        const continuous = Number(contractParam);
        if (continuous !== this.contractSelected) {
          this.onChangeContract({ item: { continuous_contract: continuous } });
        }
        return;
      }
      const monthYear = String(contractParam).toUpperCase();
      if (monthYear !== this.contractSelected) {
        this.onChangeContractMonthYear({
          item: { contract_month_year: monthYear },
        });
      }
    },
    onUserSpotChange() {
      this.updatedAt =
        "Updated by user at: " + formatDate_DDMMMYHMS(new Date());
    },
    updateCurrencySpotMethod() {
      this.commoditiesOps.getSpotData(); // get this.spotData and then this.CandleData
    },
    validateDateSpotData(data, time) {
      const chicagoTZ = "America/Chicago";
      const currentDate = new Date();
      const chicagoCurrentDate = new Date(
        currentDate.toLocaleString("en-US", { timeZone: chicagoTZ }),
      );

      const newDate = new Date(data[time]);
      if (
        +newDate > +chicagoCurrentDate &&
        chicagoCurrentDate.getHours() < 20
      ) {
        return {
          ...data,
          [time]: chicagoCurrentDate,
        };
      }

      return data;
    },
    changeViewBoolean() {
      this.selectedView = 1 - this.selectedView;
      if (this.selectedView === 0) {
        this.view = this.view_user;
      } else if (this.selectedView === 1) {
        this.view = this.view_quanspire;
      }
      this.syncMarketsRoute();
    },
    changeView(view_selection) {
      if (view_selection === "myview") {
        this.view = this.view_user;
        this.selectedView = 0;
      }
      if (view_selection === "quanspire") {
        this.view = this.view_quanspire;
        this.selectedView = 1;
      }
      this.syncMarketsRoute();
    },
    verifySpotData() {
      if (this.chartDataRaw === undefined) {
        return;
      } else if (this.chartDataRaw.length === 0) {
        return;
      }
      const spotData = this.spotData;
      const lastChartData = this.chartDataRaw.at(-1);
      if (spotData) {
        const isEndpointBack = !!spotData["last_price"];

        const observationDateTime = isEndpointBack
          ? spotData["last_observation_date"]
          : `${spotData["time"]}`;
        const dateObj = new Date(observationDateTime);
        if (+dateObj < +lastChartData?.date) {
          this["updatedAt"] =
            "Updated at: " + formatDate_DDMMMYHMS(lastChartData?.date);
          this["spot"] = +lastChartData.close;
        }
      }
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    /** ================ APIs ================  **/

    // ============ Getting menu configuration from api ===============
    onSaveView() {
      let params = {
        method: "POST",
        endpoint: "create_menu_configuration_commodity",
        content_type: "application/json",
        query_params: {
          format: "json",
          view_markets_side_menu: this.view,
          fk_iduser: this.user.pk_idusers,
          fk_commodity: this.commodityNumber,
          fk_idstate: 1,
        },
      };
      this.modal_processing_message.showModalLoading = !this
        .modal_processing_message.showModalLoading;
      this.modal_processing_message.messageModal = "Processing....";
      apiService
        .getAll(params)
        .then((data) => {
          this.modal_processing_message.showModalLoading = !this
            .modal_processing_message.showModalLoading;
          this.modal_process_finished_message.showModalLoading = !this
            .modal_process_finished_message.showModalLoading;
          this.modal_process_finished_message.optionsModal = true;
          this.modal_process_finished_message.messageModal = data;
        })
        .catch(function(error) {
          console.error("An error has occurred" + error);
          this.modal_processing_message.showModalLoading = !this
            .modal_processing_message.showModalLoading;
          this.modal_process_finished_message.showModalLoading = !this
            .modal_process_finished_message.showModalLoading;
          this.modal_process_finished_message.optionsModal = true;
          this.modal_process_finished_message.messageModal =
            "An error has occurred" + error;
        });
    },
    // ============ Getting menu configuration ===============
    receiveMessage(message) {
      let _this = this;
      const messageObject = message;
      if (this.commodityDefs.commodity_name === messageObject["contract"]) {
        let keys = Object.keys(messageObject);
        if (keys.indexOf("continuous_contract") > -1) {
          const continuousContract = +messageObject["continuous_contract"];
          if (
            +this.commodityDefs.selected_contract !== continuousContract ||
            +this.contract !== continuousContract
          ) {
            return;
          }
        }

        const date = timeParseNoNull2(messageObject["time"]);
        this.updatedAt = "Updated at: " + formatDate_DDMMMYHMS(date);
        this.spot = +messageObject["close"];
        this.spotAnimate = Math.sign(this.spot - this.previousSpot);
        setTimeout(() => {
          _this.spotAnimate = 0;
        }, 1500);
        this.previousSpot = this.spot;
        this.isDateBefore(this, this.chartDataRaw, date);
      }
      if (
        this.defaultOperation !== 0 &&
        this.spotFactor !== null &&
        this.spotFactor !== 0 &&
        this.showLoadingSpotFactor === false &&
        this.currencyHistorical.length > 0
      ) {
        if (this.currencyDefs.currency_name === messageObject["contract"]) {
          const date = new Date(messageObject["time"]);
          this.factorUpdatedAt = "Updated at: " + formatDate_DDMMMYHMS(date);
          this.spotFactor = +messageObject["close"];
          this.spotFactorAnimate = Math.sign(
            this.spotFactor - this.previousSpotFactor,
          );
          setTimeout(() => {
            _this.spotFactorAnimate = 0;
          }, 1500);
          this.previousSpotFactor = this.spotFactor;
          this.isDateBefore(this, this.chartDataRaw, date, false);
        }
      }
    },
    isDateBefore(_this, data, observationDate, isCommodity = true) {
      if (data === undefined) {
        return;
      }
      observationDate = observationDate.setHours(0, 0, 0, 0);
      const dataLastDate = data?.length
        ? [...data].at(-1).date.setHours(0, 0, 0, 0)
        : null;
      // Validate if the data is not updated
      if (+dataLastDate < +observationDate) {
        if (+new Date(_this.spotData.observation_date) < +observationDate) {
          const observDate = new Date(observationDate);
          const formatDate =
            observDate.getFullYear() +
            "-" +
            (observDate.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            observDate
              .getDate()
              .toString()
              .padStart(2, "0");
          let newSpotData = {
            close: _this.spotFactor,
            observation_date: formatDate,
          };

          Object.assign(_this.spotData, newSpotData);
        }
        Object.assign(_this, {
          chartDataRaw: _this.processData.includeSpotNew(
            _this["chartDataRaw"],
            _this["spotData"],
            false,
            isCommodity,
          ),
        });
      }
    },
    verifyLastTwoDates(_this, data) {
      // Last date
      const dataLastDate = data?.length
        ? [...data].at(-1)?.date.setHours(0, 0, 0, 0)
        : null;
      // Before last date
      const dataBeforeLastDate = data?.length
        ? [...data].at(-2)?.date.setHours(0, 0, 0, 0)
        : null;
      // validate if data does not repeat
      if (
        dataLastDate &&
        dataBeforeLastDate &&
        +dataLastDate === +dataBeforeLastDate
      ) {
        const newData = [...data];
        newData.splice(data.length - 2, 1);
        Object.assign(_this, {
          chartDataRaw: newData,
        });
      }
    },
  },
  beforeDestroy() {
    selectAll(".tooltip").remove();
  },
};
</script>

<style scoped>
.toggle__button_rt .toggle__switch_rt {
  min-height: 16px !important;
}
.active .toggle__switch_g::after {
  background: var(--expo);
  border: 1px solid var(--expo);
  box-shadow: 0 0 1px var(--graylightbackground);
  left: calc(50% - 2px) !important;
  width: 50%;
}
.toggle__button_g .toggle__switch_g::after,
.toggle__button_g .toggle__switch_g::before {
  content: "";
}
.toggle__button_rt .toggle__switch_rt::after,
.toggle__button_rt .toggle__switch_rt::before {
  content: "LAST RECORD";
  font-size: 0.58rem !important;
  padding: 0 !important;
}
.actives .toggle__switch_rt::before,
.actives .toggle__switch_rt::after {
  content: "QUANSPIRE";
}
.main-container {
  position: relative;
}
.container-fluid {
  position: relative;
  padding: 0;
}
.container {
  height: 100%;
  width: 100%;
  background-color: var(--graylightbackground-alpha4);
  border: 1px solid var(--lightbackground);
  position: absolute;
  top: 0;
  text-align: center;
}
.container-spot {
  gap: 5px;
}
</style>
